export const sortOrders = (a, b) => {
    let A = a.orderDate;
    let B = b.orderDate;

    if(A > B) {
        return -1;
    }else if(B > A) {
        return 1;
    } else {
        return 0;
    }
}

export const convertDate = (date) => {
    let dateArray = date.split('-');

    let year = dateArray[0];
    let month = dateArray[1];
    let day = dateArray[2];

    let formattedDate = `${day}.${month}.${year}`;

    return formattedDate;
}

export const switchTakeTypeOrder = (status) => {
    switch(status) {
        case 'eatIn':
          return 'Ð ÐºÐ°ÑÐµ';
        case 'takeOut':
          return 'ÐÐ°Ð²ÑÐ½Ð¾Ñ';
        case 'delivery':
          return 'ÐÐ¾ÑÑÐ°Ð²ÐºÐ°';
      }
}

export const switchTakeTypeDMOrder = (status) => {
    switch(status) {
        case 'takeOut':
          return 'Ð¡Ð°Ð¼Ð¾Ð²ÑÐ²Ð¾Ð·';
        case 'delivery':
          return 'ÐÐ¾ÑÑÐ°Ð²ÐºÐ°';
      }
}